import { useEffect, useRef, useState } from 'preact/hooks';
import {
  CHATBOT_CHAT_MSJ_FROM_BOT,
  CHATBOT_CHAT_MSJ_FROM_CLIENT,
  CHATBOT_ERROR_MESSAGE_MIN_CHAR,
  CHATBOT_PLACEHOLDER_INPUT,
} from '../utils/constants.js';
import clsx from 'clsx';
import AudioRecorderChatbot from './audioRecorderChatbot.jsx';
import SendButtonImgChatbot from './sendButtonImgChatbot.jsx';

export default function ChatInputFormChatbot({ sendMessage, isLoading, inputValueState }) {
  const [isRecording, setIsRecording] = useState(false);
  const inputValue = inputValueState.value;
  const setInputValue = (value) => (inputValueState.value = value);
  const textareaRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    adjustTextareaHeight();
    textareaRef.current.style.height = '2vh';
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    const toEvaluate = inputValue.trim();
    if (!toEvaluate || isLoading) return;

    if (toEvaluate.length < 3) {
      sendMessage({
        from: CHATBOT_CHAT_MSJ_FROM_BOT,
        message: CHATBOT_ERROR_MESSAGE_MIN_CHAR,
      });
      return;
    }
    sendMessage({
      from: CHATBOT_CHAT_MSJ_FROM_CLIENT,
      message: toEvaluate,
    });
    setInputValue('');
    removeAdjustTextareaHeight();
  };

  const onInput = (e) => {
    setInputValue(e.currentTarget.value);
    if(e.currentTarget.value === ''){
      textareaRef.current.style.height = '2vh';
    }else{
      adjustTextareaHeight();
    }
  };

  const adjustTextareaHeight = () => {
    if (textareaRef.current && inputValue.length > 30) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `auto`;
    }
  };
  
  const removeAdjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = '2vh';
    }
  };

  const onEnterSubmit = (e) => {
    if(e.key === 'Enter' && e.shiftKey){
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}vh`;
    }
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit(e);
    }
  };

  return (
    <div className={clsx(
          'bot-utn-input-area',
          {'bot-utn-on-focus': isFocused}
          )}
    >
      <form id="bot-utn-input-form">
        <div className={
          clsx(
            'bot-utn-div-textarea',
            {'bot-utn-div-textarea-recording': isRecording}
            )}>
          <textarea
            disabled={isLoading}
            ref={textareaRef}
            className={clsx(
              'bot-utn-textarea',
              'bot-utn-textarea-auto-resize',
              'bot-utn-scrollbar',
              {
                'bot-utn-on-focus': isFocused
              }
            )}
            type="text"
            placeholder={CHATBOT_PLACEHOLDER_INPUT}
            value={inputValue}
            onInput={onInput}
            onKeyDown={onEnterSubmit}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
          <AudioRecorderChatbot isLoading={isLoading} sendMessage={sendMessage} textareaRef={textareaRef} setIsRecording={setIsRecording} isRecording={isRecording}/>
        </div>
        {!isRecording &&
         <button 
           disabled={isLoading}
           className={clsx({
            'bot-utn-button-disabled': isLoading,
            'bot-utn-button': !isLoading
          })}
           type="submit" 
           onClick={onSubmit}
         >
          <SendButtonImgChatbot inputValueState={inputValueState.value}/>
        </button>}
      </form>
    </div>
  );
}
